import React from 'react';
import Header from './Header';

const PublicLayout = ({
  title,
  showBack = false,
  backTo = -1,
  onBackClick,
  actions = [],
  breadcrumbs = [],
  className = '',
  children
}) => {
  return (
    <div className="min-h-screen bg-gray-50" style={{ background: 'var(--bg)' }}>
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 50,
          background: 'var(--bg)',
          borderBottom: '1px solid var(--border)',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          padding: '12px 16px',
        }}
      >
        <Header
          title={title}
          showBack={showBack}
          backTo={backTo}
          onBackClick={onBackClick}
          actions={actions}
          breadcrumbs={breadcrumbs}
        />
      </div>

      <main
        className={`public-layout-main ${className}`.trim()}
        style={{
          minHeight: 'calc(100vh - 73px)',
          padding: '16px',
        }}
      >
        {children}
      </main>
    </div>
  );
};

export default PublicLayout;
